import React from "react";
import CommunityCard from "./CommunityCard";

const CommunityView = ({ currentRecord }) => {
  return <CommunityCard data={currentRecord} />;
  // return <div className="">{JSON.stringify(currentRecord)}</div>;
};

export default CommunityView;
